/**
 * Barra de navegación fija al desplazar (menú horizontal, ≥ 992 px).
 *
 * Con histéresis: se fija al pasar FIJAR px de scroll y se suelta solo al volver
 * por debajo de SOLTAR (el alto de la barra superior: ahí su lugar natural ya
 * está a la vista, así que soltarla no la hace saltar). Entre los dos umbrales
 * conserva el estado que traía: un scroll que va y viene cerca del umbral no la
 * hace parpadear. Por debajo de 992 px la barra es el cajón del menú móvil y
 * nunca se fija.
 */
export var FIJAR = 60;
export var SOLTAR = 48;

export function estadoFijo(fija, y, escritorio) {
  if (!escritorio) return false;
  return fija ? y >= SOLTAR : y >= FIJAR;
}
